/**
 * Generated by scripts/optimise-uploads.js - do not edit by hand.
 *
 * The uploaded images, with their intrinsic size and the WebP versions
 * generated for them. Keyed by the path stored in the content files.
 */

export interface UploadVariant {
  width: number;
  src: string;
}

export interface UploadInfo {
  /** Intrinsic size of the original, so the browser can reserve the space. */
  width: number;
  height: number;
  variants: UploadVariant[];
}

export const UPLOADS: Record<string, UploadInfo> = {
  "/uploads/Bildschirmfoto 2026-08-07 um 10.41.57.png": {
    "width": 2800,
    "height": 664,
    "variants": [
      {
        "width": 400,
        "src": "/uploads/optimised/Bildschirmfoto 2026-08-07 um 10.41.57-400.webp"
      },
      {
        "width": 800,
        "src": "/uploads/optimised/Bildschirmfoto 2026-08-07 um 10.41.57-800.webp"
      },
      {
        "width": 1600,
        "src": "/uploads/optimised/Bildschirmfoto 2026-08-07 um 10.41.57-1600.webp"
      }
    ]
  }
};
